import { render, staticRenderFns } from "./cowVaccinationList.vue?vue&type=template&id=3035a313&scoped=true&"
import script from "./cowVaccinationList.vue?vue&type=script&lang=js&"
export * from "./cowVaccinationList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3035a313",
  null
  
)

export default component.exports